// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import toBeDeliveryDeployMng from './metaData/toBeDeliveryDeploy'
export default {
  state: toBeDeliveryDeployMng,
  actions
}
